var map = {
	"./buySpineItemBg1.png": 99267,
	"./buySpineItemBg2-tag.png": 71666,
	"./buySpineItemBg2.png": 23474,
	"./buySpineItemBg3-tag.png": 37315,
	"./buySpineItemBg3.png": 20463,
	"./firend-head.jpg": 74611,
	"./icon/icon-buyTicket.png": 71728,
	"./icon/icon-coin.png": 31310,
	"./icon/icon-correctPrediction.png": 82857,
	"./icon/icon-deposit.png": 76266,
	"./icon/icon-instantReward.png": 51058,
	"./icon/icon-star.png": 71923,
	"./icon/icon-taskCompleted.png": 99016,
	"./icon/icon-wrongPrediction.png": 6207,
	"./icon/pop-invitationReward.png": 25560,
	"./leaders-head.png": 87050,
	"./loading-bg.jpg": 29093,
	"./m1.jpg": 99732,
	"./m2.jpg": 17800,
	"./m3.jpg": 9612,
	"./no-img.png": 25703,
	"./pop-earn-ticket-img.png": 19995,
	"./task-head.jpg": 85474,
	"./yes-img.png": 26080,
	"./youtube.png": 52674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;